import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { Button, Col, Form, Row } from "react-bootstrap";
import moment from "moment";
import Slider from "react-slick";
import DatePicker from "react-datepicker";

import logoUrl from "../Assets/images/logo.png";

import { API } from "../utils/api";
import {
  calcultePrice,
  calculateCustomAmount,
  convertTimeTo12h,
  getDistance,
  getFilterDate,
  getTimeFrame,
  hasTimePassed,
  isFlatRateSpot,
  showToast,
} from "../utils/helper";
import { trackEvent } from "../utils/analytics";
import { GOOGLE_API_KEY, env as appEnv } from "../utils/env";
import {
  availableTimes,
  customTimesFilters,
  defaultAvailability,
  timeFilters,
  vehiclesList,
} from "../Constants";
import {
  compactVehicleImg,
  defaultImg,
  standardVehicleImg,
  suvVehicleImg,
} from "../Constants/images";
import { useDispatch, useSelector } from "react-redux";
import LoginModal from "./Component/Models/LoginModal";
import AddVehicleModal from "./Component/Models/AddVehicleModal";
import ConfirmCustomBooking from "./Component/Models/ConfirmCustomBooking";
import { setStripeKey } from "../Store/Reducers/AuthReducers";
import { getUserVehiclesListAction } from "../Store/Actions/VehicleActions";
import ExecutePayment from "./Component/ExecutePayment";
import usePaymentRedirectReturn from "../utils/usePaymentRedirectReturn";

const SpotBooking = () => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);
  const [myVehicles, setMyVehicles] = useState([]);

  usePaymentRedirectReturn(() => navigate("/user/bookings"));

  const spotId = params.spotId ? params.spotId : "";

  const defaultData = {
    type: "normal",
    spotId: spotId,
    bookingDate: moment(new Date()).format("YYYY-MM-DD"),
    day: "",
    timeFrame: "15 minutes",
    arrivalTime: "",
    endDate: "",
    endTime: "",
    offerPrice: "",
    vehicleLicense: "",
    vehicleId: "",
    price: "",
  };

  const [spot, setSpotData] = useState({});
  const [data, setData] = useState(defaultData);
  const [loadingTime, setLoadingTime] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showLoginModal, setLoginModal] = useState(false);
  const [showAddVehicleModal, setShowAddVehicleModal] = useState(false);
  const [confirmCustomBooking, setConfirmCustomBooking] = useState({
    show: false,
  });
  const [showMap, setShowMap] = useState(false);
  const [showPaymentModal, setPaymentnModal] = useState({
    show: false,
    paymentInfo: {},
    bookingInfo: {},
  });

  const [availableTimes, setAvailableTimes] = useState([]);
  const [unavailableDate, setUnavailableDate] = useState([]);
  const [location, setLocation] = useState(null);
  const [isFirstAvailbleReady, setIsFirstAvailbleReady] = useState(false);
  const [isSpotReady, setIsSpotReady] = useState(false);

  const mapRef = useRef(null);
  const [spotMarker, setSpotMarker] = useState({
    lat: 38.905778525393636,
    lng: -77.01938252900719,
  });
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: GOOGLE_API_KEY,
    libraries: ["places"],
  });

  const onChange = (field, value) => {
    setData({
      ...data,
      [field]: value,
    });
  };

  const getSpotDetails = () => {
    if (spotId) {
      API.getSingleSpot(spotId)
        .then((res) => {
          if (res.type === "success") {
            //
            setIsSpotReady(true);
            setSpotData({ ...res.data });
            setData({
              ...data,
              price: res.data.ratePerHour,
            });

            if (res.data.location && res.data.location.coordinates) {
              setSpotMarker({
                lat: res.data.location.coordinates[1],
                lng: res.data.location.coordinates[0],
              });
            }
          }
        })
        .catch((err) => {
          //
          showToast(`ERR : ${err.message}`);
        });
    } else {
      showToast(`ERR : spot id is missing , ${spotId}`);
    }
  };

  const loadAvailabilty = () => {
    if (!loadingTime && data.bookingDate !== "" && data.timeFrame !== "") {
      setLoadingTime(true);

      const chooseDate = data.bookingDate;
      const temp = String(data.timeFrame).split(" ");

      let duration;
      if (temp[1] === "minutes") {
        duration = parseInt(temp[0]);
      } else if (temp[1] === "hour" || temp[1] === "hours") {
        duration = parseInt(temp[0]) * 60;
      } else if (temp[1] === "day" || temp[1] === "days") {
        duration = parseInt(temp[0]) * 60 * 24;
      }

      // const duration = temp[1] === "minutes" ? parseInt(temp[0]) : temp[0] * 60;

      API.getDateSlots({
        type: data.type,
        spotId: data.spotId,
        date: chooseDate,
        duration,
      })
        .then((res) => {
          setLoadingTime(false);

          console.log("REs TIMES:", res);

          if (res.type === "success") {
            setAvailableTimes(res.data && res.data.slots ? res.data.slots : []);
          } else {
            setAvailableTimes([]);
          }
        })
        .catch((err) => {
          setLoadingTime(false);
          showToast(err.message);
        });
    }
  };

  const getUnavailableDate = () => {
    const temp = String(data.timeFrame).split(" ");

    let duration;
    if (temp[1] === "minutes") {
      duration = parseInt(temp[0]);
    } else if (temp[1] === "hour" || temp[1] === "hours") {
      duration = parseInt(temp[0]) * 60;
    } else if (temp[1] === "day" || temp[1] === "days") {
      duration = parseInt(temp[0]) * 60 * 24;
    }

    API.getUnavailableDate(spot.id, { duration, type: data.type })
      .then((res) => {
        if (res.firstAvailableDate) {
          setIsFirstAvailbleReady(true);
          const newDate = res.firstAvailableDate; // new Date(res.firstAvailableDate);

          onChange("bookingDate", newDate);
        }

        if (
          res.type === "success" &&
          res.bookedDates &&
          res.bookedDates.length > 0
        ) {
          setUnavailableDate(res.bookedDates);
        } else {
          setUnavailableDate([]);
        }
      })
      .catch((err) => {});
  };

  // Re-pull slots + booked dates after a booking so the just-taken window
  // disappears without a manual page reload.
  const refreshAvailability = () => {
    getUnavailableDate();
    loadAvailabilty();
  };

  const getVehicles = () => {
    const params = {
      page: 1,
      limit: 50,
    };

    API.getUserVehicles(params).then((res) => {
      if (res && res.data) {
        const vehicles = res.data ? res.data : [];
        setMyVehicles(vehicles);
      } else {
        setMyVehicles([]);
      }
    });

    const keyType = appEnv === "prod" ? "live" : "test";
    API.getPublicKeys({ type: keyType })
      .then((res) => {
        if (
          res &&
          res.type === "success" &&
          res.data &&
          res.data.stripePublicKey
        ) {
          dispatch(setStripeKey({ key: res.data.stripePublicKey }));
        }
      })
      .catch(() => {});
  };

  const validateForm = () => {
    let err = false;

    const currentTime = moment();
    const startDateTime = moment(
      `${data.bookingDate} ${data.arrivalTime}`,
      "YYYY-MM-DD HH:mm",
    );
    const endDateTime = moment(
      `${data.endDate} ${data.endTime}`,
      "YYYY-MM-DD HH:mm",
    );

    if (myVehicles.length === 0) {
      err = true;
      showToast("error", "Add your vehicle first");
      setShowAddVehicleModal(true);
    } else if (data.vehicleLicense === "") {
      err = true;
      showToast("error", "Please select your vehicle");
    } else if (data.bookingDate === "") {
      err = true;
      showToast("error", "Please choose date");
    } else if (data.type === "normal" && data.timeFrame === "") {
      err = true;
      showToast("error", "Please choose time frame");
    } else if (data.arrivalTime === "") {
      err = true;
      showToast("error", "Please choose arrival time");
    } else if (data.type === "custom" && data.endDate === "") {
      err = true;
      showToast("error", "Please choose end date");
    } else if (data.type === "custom" && data.endTime === "") {
      err = true;
      showToast("error", "Please choose end time");
    } else if (data.type === "custom" && startDateTime.isBefore(currentTime)) {
      err = true;
      showToast("error", "The start time should be after the current time");
    } else if (data.type === "custom" && startDateTime.isAfter(endDateTime)) {
      err = true;
      showToast("error", "The end time should be after the start time.");
    } else if (
      data.type === "custom" &&
      startDateTime.format("YYYY-MM-DD") === endDateTime.format("YYYY-MM-DD")
    ) {
      err = true;
      showToast(
        "error",
        "Please select an end time that's at least one day later",
      );
    }

    return err;
  };

  const submitBooking = () => {
    const errs = validateForm();

    if (!errs && !loading) {
      const bookingData = getBookingData();
      setLoading(true);

      trackEvent("web_booking_submit", {
        spot_id: data.spotId,
        booking_type: data.type,
      });

      API.createBooking(bookingData)
        .then((res) => {
          if (res && res.type === "success") {
            if (
              data.type === "normal" &&
              res.data &&
              res.data.payment &&
              res.data.payment.clientSecret
            ) {
              const payment = res.data.payment;
              trackEvent("web_booking_created", {
                spot_id: data.spotId,
                booking_type: data.type,
                requires_payment: true,
              });
              setPaymentnModal({
                show: true,
                bookingInfo: res.data.booking,
                paymentInfo: {
                  ...payment,
                  paymentIntentClientSecret: payment.clientSecret,
                  stripePaymentIntentId:
                    payment.stripePaymentIntentId ||
                    (payment.clientSecret
                      ? payment.clientSecret.split("_secret_")[0]
                      : undefined),
                },
              });
              return;
            }

            trackEvent("web_booking_created", {
              spot_id: data.spotId,
              booking_type: data.type,
              requires_payment: false,
            });
            showToast(
              "success",
              res.message || "Booking request sent! Waiting for host approval.",
            );

            if (data.type === "normal") {
              setData({ ...data, arrivalTime: "" });
            } else {
              const startMoment = moment().add(2, "minutes");
              const endMoment = startMoment.clone().add(2, "days");

              setData({
                ...data,
                arrivalTime: startMoment.format("HH:mm"),
                bookingDate: startMoment.format("YYYY-MM-DD"),
                endDate: endMoment.format("YYYY-MM-DD"),
                endTime: startMoment.format("HH:mm"),
              });
            }

            // The just-booked window is now taken — refresh slots + booked dates.
            refreshAvailability();
          } else {
            showToast(
              "error",
              (res && res.message) || "Booking failed. Please try again.",
            );
          }
        })
        .catch((err) => {
          showToast(
            "error",
            (err && err.message) || "Booking failed. Please try again.",
          );
        })
        .finally(() => setLoading(false));
    }
  };

  const getBookingData = () => {
    let startDate, startTime, endDate, endTime, grossAmount;

    if (data.type === "normal") {
      startDate = moment(data.bookingDate).set({
        hour: moment(data.arrivalTime, ["hh:mmA", "hh:mm A"]).hour(),
        minute: moment(data.arrivalTime, ["hh:mmA", "hh:mm A"]).minute(),
        second: 0,
        millisecond: 0,
      });

      startTime = startDate.format("HH:mm");
      const temp = String(data.timeFrame).split(" ");

      const endMoment = startDate.clone().add(temp[0], temp[1]);
      endTime = endMoment.format("HH:mm");
      endDate = endMoment.format("YYYY-MM-DD");

      grossAmount = isFlatRateSpot(spot)
        ? parseFloat(spot.flatRate || 0).toFixed(2)
        : calcultePrice(spot.ratePerHour, data.timeFrame);
    } else {
      startDate = moment(data.bookingDate);
      startTime = data.arrivalTime;
      endDate = data.endDate;
      endTime = data.endTime;

      grossAmount = isFlatRateSpot(spot)
        ? parseFloat(spot.flatRate || 0).toFixed(2)
        : calculateCustomAmount(
            spot.ratePerHour,
            data.bookingDate,
            data.arrivalTime,
            data.endDate,
            data.endTime,
          );
    }

    const bookingData = {
      type: String(data.type).toLowerCase(),
      vehicleId: data.vehicleId,
      spotId: data.spotId,
      day: startDate.format("ddd"),
      grossAmount: parseFloat(grossAmount),
      startDate: data.bookingDate,
      startTime,
      endDate,
      endTime,
    };

    if (data.type === "custom") {
      bookingData.offeredAmount = parseFloat(data.offerPrice);
    } else {
      bookingData.offeredAmount = parseFloat(grossAmount);
    }

    return bookingData;
  };

  useEffect(() => {
    if (spot) {
      getVehicles();
    }
  }, [isAuthenticated, spot]);

  useEffect(() => {
    if (myVehicles.length > 0) {
      setData({
        ...data,
        vehicleId: myVehicles[0].id,
        vehicleLicense: myVehicles[0].licensePlate,
      });
    }
  }, [myVehicles]);

  useEffect(() => {
    if (isSpotReady && isFirstAvailbleReady) {
      loadAvailabilty();
    }
  }, [data.bookingDate, data.timeFrame]);

  useEffect(() => {
    if (data.type === "custom") {
      const startMoment = moment().add(2, "minutes");
      const endMoment = startMoment.clone().add(2, "days");
      setData((prev) => ({
        ...prev,
        arrivalTime: startMoment.format("HH:mm"),
        bookingDate: startMoment.format("YYYY-MM-DD"),
        endDate: endMoment.format("YYYY-MM-DD"),
        endTime: startMoment.format("HH:mm"),
        timeFrame: customTimesFilters[0].value,
      }));
    } else {
      setData((prev) => ({
        ...prev,
        arrivalTime: "",
        timeFrame: timeFilters[0].value,
      }));
    }
  }, [data.type]);

  useEffect(() => {
    if (isSpotReady && !isFirstAvailbleReady) {
      getUnavailableDate();
    }

    if (isSpotReady && isFirstAvailbleReady) {
      console.log("Loding blocks after ready...");

      loadAvailabilty();
    }
  }, [isSpotReady, isFirstAvailbleReady]);

  useEffect(() => {
    window.location = `spotieapp://booking/${spotId}`;

    getSpotDetails();
  }, []);

  useEffect(() => {
    if (
      spot &&
      spot.availabilityMode === "custom_dates" &&
      data.type === "custom"
    ) {
      setData((prev) => ({ ...prev, type: "normal" }));
    }
  }, [spot, data.type]);

  useEffect(() => {
    if (data.type !== "custom") return;
    if (
      !data.bookingDate ||
      !data.arrivalTime ||
      !data.endDate ||
      !data.endTime
    )
      return;
    if (!spot || (!isFlatRateSpot(spot) && !spot.ratePerHour)) return;

    const offerPrice = isFlatRateSpot(spot)
      ? parseFloat(spot.flatRate || 0).toFixed(2)
      : calculateCustomAmount(
          spot.ratePerHour,
          data.bookingDate,
          data.arrivalTime,
          data.endDate,
          data.endTime,
        );

    setData((prev) => ({ ...prev, offerPrice }));
  }, [
    data.type,
    data.bookingDate,
    data.arrivalTime,
    data.endDate,
    data.endTime,
    spot,
  ]);

  useEffect(() => {
    if (!navigator.geolocation) {
      console.log("Geolocation is not supported by your browser");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLocation({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      (err) => {
        console.log(`Error getting location: ${err.message}`);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      },
    );
  }, []);

  let increments;
  if (data.type === "normal") {
    increments = timeFilters.filter((item) => item.value === data.timeFrame);
  } else {
    increments = customTimesFilters.filter(
      (item) => item.value === data.timeFrame,
    );
  }

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="spot-details-container">
      <div className="map-container">
        <div className="container">
          <div className="map-heading">
            <div
              className="logo-wrapper asLink"
              onClick={() => navigate("/user/spots")}
            >
              <img src={logoUrl} alt="" />
              {/* <i className="fas fa-home" /> */}
            </div>

            {!isAuthenticated && (
              <Button onClick={() => setLoginModal(true)}>
                <span>Login</span>
              </Button>
            )}
          </div>

          <div className={`map-wrapper ${!showMap ? "image-slider-w" : ""}`}>
            {showMap && isLoaded && spot && (
              <GoogleMap
                ref={mapRef}
                mapContainerStyle={{ width: "100%", height: 250 }}
                center={spotMarker}
                zoom={12}
                // onUnmount={onUnmount}
              >
                {spotMarker && spotMarker.lat !== 0 && (
                  <Marker position={spotMarker} />
                )}
              </GoogleMap>
            )}

            {!showMap && (
              <div className="image-slider">
                {spot && (!spot.images || spot.images.length === 0) && (
                  <div className="slider-item">
                    <img src={defaultImg} alt="" />
                  </div>
                )}

                {spot && spot.images && spot.images.length > 0 && (
                  <Slider {...sliderSettings}>
                    {spot.images.map((item, index) => (
                      <div className="slider-item" key={`slider-img-${index}`}>
                        <img src={item} alt="" />
                      </div>
                    ))}
                  </Slider>
                )}
              </div>
            )}
          </div>

          <div className="map-img-switch">
            <span
              className={`switch-icon ${showMap ? "active" : ""}`}
              onClick={() => setShowMap(true)}
            >
              <i class="fas fa-map-location-dot"></i>
            </span>

            <span
              className={`switch-icon ${!showMap ? "active" : ""}`}
              onClick={() => setShowMap(false)}
            >
              <i className="fas fa-images" />
            </span>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="spot-details">
          <div className="spot-heading">
            <h3>{spot.name}</h3>

            {spot.location && location && (
              <p>
                {getDistance(spot.location, location)} miles from destination
              </p>
            )}

            {spot.hasEvCharger && (
              <span className="ev-charger-badge">
                <i className="fas fa-bolt me-1" />
                EV charger available
              </span>
            )}
          </div>

          {isAuthenticated && myVehicles.length > 0 && (
            <div className="vehicles-list-wrapper">
              {myVehicles.map((item, index) => {
                const vehicleTypeImg =
                  item.type === "compact"
                    ? compactVehicleImg
                    : item.type === "standard"
                      ? standardVehicleImg
                      : suvVehicleImg;

                const isActive = data.vehicleId === item.id ? "active" : "";

                return (
                  <div
                    className="vehicle-item"
                    key={`vehicle-item-${item.id}-${index}`}
                    onClick={() => {
                      setData({
                        ...data,
                        vehicleId: item.id,
                        vehicleLicense: item.licensePlate,
                      });
                    }}
                  >
                    <div className={`vehicle-image ${isActive}`}>
                      <img src={vehicleTypeImg} alt="Vehicle Item" />
                    </div>
                    <p>{item.licensePlate}</p>
                  </div>
                );
              })}
            </div>
          )}

          {spot && spot.availabilityMode !== "custom_dates" && (
            <div className="booking-type-wrapper">
              <p className="booking-type-label">Booking Type</p>
              <div className="booking-type-options">
                <button
                  type="button"
                  className={`booking-type-option ${data.type === "normal" ? "active" : ""}`}
                  onClick={() => onChange("type", "normal")}
                >
                  <span className="booking-type-radio">
                    {data.type === "normal" && <i className="fas fa-check" />}
                  </span>
                  Short Term
                </button>
                <button
                  type="button"
                  className={`booking-type-option ${data.type === "custom" ? "active" : ""}`}
                  onClick={() => onChange("type", "custom")}
                >
                  <span className="booking-type-radio">
                    {data.type === "custom" && <i className="fas fa-check" />}
                  </span>
                  Long Term
                </button>
              </div>
            </div>
          )}

          <div className="date-fields">
            {data.type === "normal" && (
              <Row>
                <Col>
                  <select
                    className="form-control"
                    onChange={(e) => onChange("timeFrame", e.target.value)}
                    value={data.timeFrame}
                  >
                    <option>Select</option>
                    {timeFilters.map((item, index) => (
                      <option key={`dropdown-item-${index}`} value={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </select>
                </Col>

                <Col>
                  <DatePicker
                    showIcon={true}
                    icon="far fa-calendar"
                    minDate={new Date()}
                    maxDate={spot && spot.currentDayOnly ? new Date() : null}
                    className="form-control"
                    placeholderText="MM/DD/YYYY"
                    selected={moment(data.bookingDate)}
                    value={getFilterDate(data.bookingDate)}
                    onChange={(date) => {
                      const d = moment(date).format("YYYY-MM-DD");
                      onChange("bookingDate", d);
                    }}
                    filterDate={(date) => {
                      const day = date.getDay();
                      const workingDays = spot.days || [];

                      const indexes = defaultAvailability.reduce(
                        (acc, item, i) => {
                          if (!workingDays.includes(item.day)) acc.push(i);
                          return acc;
                        },
                        [],
                      );

                      return !indexes.includes(day);
                    }}
                  />
                </Col>
              </Row>
            )}

            {data.type === "custom" && (
              <>
                <Row>
                  <Col>
                    <Form.Label className="fw-bold">Start Date</Form.Label>
                    <DatePicker
                      showIcon={true}
                      icon="far fa-calendar"
                      minDate={new Date()}
                      maxDate={spot && spot.currentDayOnly ? new Date() : null}
                      className="form-control"
                      placeholderText="MM/DD/YYYY"
                      selected={moment(data.bookingDate).toDate()}
                      value={getFilterDate(data.bookingDate)}
                      onChange={(date) => {
                        const d = moment(date).format("YYYY-MM-DD");
                        onChange("bookingDate", d);
                      }}
                    />
                  </Col>
                  <Col>
                    <Form.Label className="fw-bold">Start Time</Form.Label>
                    <Form.Control
                      type="time"
                      value={data.arrivalTime}
                      onChange={(e) => onChange("arrivalTime", e.target.value)}
                    />
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col>
                    <Form.Label className="fw-bold">End Date</Form.Label>
                    <DatePicker
                      showIcon={true}
                      icon="far fa-calendar"
                      minDate={moment(data.bookingDate).toDate()}
                      maxDate={spot && spot.currentDayOnly ? new Date() : null}
                      className="form-control"
                      placeholderText="MM/DD/YYYY"
                      selected={
                        data.endDate ? moment(data.endDate).toDate() : null
                      }
                      value={data.endDate ? getFilterDate(data.endDate) : ""}
                      onChange={(date) => {
                        const d = moment(date).format("YYYY-MM-DD");
                        onChange("endDate", d);
                      }}
                    />
                  </Col>
                  <Col>
                    <Form.Label className="fw-bold">End Time</Form.Label>
                    <Form.Control
                      type="time"
                      value={data.endTime}
                      onChange={(e) => onChange("endTime", e.target.value)}
                    />
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col>
                    <Form.Label className="fw-bold">Offered Amount</Form.Label>
                    <div className="input-group">
                      <span className="input-group-text">$</span>
                      <Form.Control
                        type="number"
                        placeholder="Amount"
                        value={data.offerPrice}
                        onChange={(e) => onChange("offerPrice", e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>
              </>
            )}
          </div>

          {data.type === "normal" && (
            <div className="time-blocks-wrapper">
              <div className="time-blocks-heading">
                <span className="label">Arrival Time</span>
                {increments.length > 0 && (
                  <span>{`${increments[0]["label"]} `} increments</span>
                )}
              </div>

              <div className="time-blocks">
                {loadingTime && (
                  <p className="text-center w-100 mt-5 mb-4">
                    <i
                      className="fas fa-spin fa-spinner"
                      style={{ fontSize: 25 }}
                    />
                  </p>
                )}

                {!loadingTime && availableTimes.length == 0 && (
                  <p className="text-center w-100 mt-2 mb-3">
                    {`No time blocks available on ${data.bookingDate} for ${data.timeFrame}`}
                  </p>
                )}

                {!loadingTime && availableTimes.length > 0 && (
                  <Row>
                    {availableTimes.map((item, index) => {
                      const isTimePassed =
                        spot && spot.timeZone
                          ? hasTimePassed(
                              spot.timeZone,
                              item.start,
                              data.bookingDate,
                            )
                          : false;

                      if (item.booked || isTimePassed) return null;

                      const isActive =
                        data.arrivalTime === item.start ? "active" : "";
                      return (
                        <Col md={3} xs={6} key={`arrival-time-${index}`}>
                          <div
                            className={`arrival-time-item ${isActive}`}
                            onClick={() => {
                              onChange("arrivalTime", item.start);
                            }}
                          >
                            {convertTimeTo12h(item.start)}
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                )}
              </div>
            </div>
          )}

          <div className="button-wrapper">
            <Button
              type="button"
              className="btn-primary"
              onClick={() => {
                if (!isAuthenticated) {
                  setLoginModal(true);
                  return;
                }

                if (data.type === "normal") {
                  submitBooking();
                } else {
                  if (!validateForm()) {
                    setConfirmCustomBooking({ show: true });
                  }
                }
              }}
            >
              <span>
                {loading && <i className="fas fa-spin fa-spinner" />}
                {!loading &&
                  (spot && spot.requiresApproval
                    ? "Request Booking"
                    : "Book Now")}
              </span>
            </Button>
          </div>
        </div>
      </div>

      {showLoginModal && (
        <LoginModal
          show={showLoginModal}
          onClose={() => setLoginModal(false)}
          onSuccess={() => {
            setLoginModal(false);
          }}
        />
      )}

      {showAddVehicleModal && (
        <AddVehicleModal
          show={showAddVehicleModal}
          onClose={() => setShowAddVehicleModal(false)}
          onSuccess={(vehicle) => {
            if (vehicle && vehicle.id) {
              setMyVehicles((prev) => [...prev, vehicle]);
              setData((prev) => ({
                ...prev,
                vehicleId: vehicle.id,
                vehicleLicense: vehicle.licensePlate,
              }));
            } else {
              getVehicles();
            }
          }}
        />
      )}

      {confirmCustomBooking.show && (
        <ConfirmCustomBooking
          show={confirmCustomBooking.show}
          spot={spot}
          data={data}
          onClose={() => setConfirmCustomBooking({ show: false })}
          onConfirm={(price) => {
            setData((prev) => ({ ...prev, offerPrice: price }));
            setConfirmCustomBooking({ show: false });
            submitBooking();
          }}
        />
      )}

      {showPaymentModal.show && showPaymentModal.paymentInfo && (
        <ExecutePayment
          show={showPaymentModal.show}
          bookingInfo={showPaymentModal.bookingInfo}
          paymentInfo={showPaymentModal.paymentInfo}
          onClose={() =>
            setPaymentnModal({ show: false, paymentInfo: {}, bookingInfo: {} })
          }
          resetForm={() => setData(defaultData)}
          onSuccess={() => {
            setData(defaultData);
            setPaymentnModal({ show: false, paymentInfo: {}, bookingInfo: {} });
            navigate("/user/bookings");
          }}
        />
      )}

      {/* {JSON.stringify(data)} */}
    </div>
  );
};

export default SpotBooking;
